'use client';

import { Trans } from '@kit/ui/trans';

import { CLIENT_LOGOS } from '~/lib/marketing/client-logos';
import { FadeIn } from './animations';

const FONT_INTER = 'var(--font-inter-agency), -apple-system, sans-serif';

// The client-logo set is the shared registry (single edit surface, Rule #8) —
// the same list also feeds the Flow platform proof block.
const trustLogos = CLIENT_LOGOS;

export function TrustSection() {
  return (
    <section
      className="border-border border-t px-8 py-32 md:px-16 md:py-44"
      data-testid="trust-section"
    >
      <div className="mx-auto max-w-6xl">
        <FadeIn>
          <p
            className="text-muted-foreground mb-20 text-xs tracking-[0.3em] uppercase"
            style={{ fontFamily: FONT_INTER }}
          >
            <Trans i18nKey="agency:trust.eyebrow" />
          </p>
        </FadeIn>
        <div
          className="bg-border grid grid-cols-2 gap-px md:grid-cols-4"
          data-testid="trust-logos"
        >
          {trustLogos.map((logo, i) => (
            <FadeIn
              key={logo.name}
              delay={0.06 * i}
              className="bg-background flex items-center justify-center px-6 py-10"
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={logo.src}
                alt={logo.name}
                data-testid={`trust-logo-${i}`}
                style={{
                  height: '56px',
                  width: '100%',
                  maxWidth: '180px',
                  objectFit: 'contain',
                  filter: 'grayscale(1) opacity(0.45)',
                  transition: 'filter 0.5s ease',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.filter = 'grayscale(0) opacity(1)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.filter = 'grayscale(1) opacity(0.45)')
                }
              />
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
